<template>
  <div class="pan-search-page">
    <div class="ui container">
      <!-- 搜索框 -->
      <div class="search-box m-padded-tb-big">
        <div class="ui large action input" style="max-width: 600px; margin: 0 auto; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); border-radius: 8px; overflow: hidden;">
          <input 
            type="text" 
            v-model="keyword" 
            placeholder="请输入搜索关键词" 
            @keyup.enter="search"
            class="m-text-spaced" 
            style="font-size: 16px; padding: 12px; border-radius: 8px 0 0 8px;"
            :disabled="!serviceHealthy"
          >
          <button class="ui blue button" @click="search" :disabled="!serviceHealthy" style="font-size: 16px; padding: 0 25px; border-radius: 0 8px 8px 0; transition: all 0.3s ease;">
            <i class="search icon"></i>搜索
          </button>
        </div>
      </div>

      <!-- 服务状态 -->
      <div v-if="checkingHealth" class="service-status m-padded-tb-big">
        <div class="ui active centered inline loader"></div>
        <span class="m-margin-left-no">检查服务状态...</span>
      </div>

      <div v-else-if="!serviceHealthy" class="service-status m-padded-tb-big">
        <div class="ui negative message">
          <div class="header">服务不可用</div>
          <p>网盘搜索服务暂时不可用，请稍后再试</p>
          <button class="ui primary button" @click="checkServiceHealth">
            <i class="refresh icon"></i>重新检查
          </button>
        </div>
      </div>

      <!-- 搜索结果 -->
      <div v-else-if="loading" class="loading m-padded-tb-big">
        <div class="ui active centered inline loader"></div>
      </div>

      <div v-else-if="error" class="error m-padded-tb-big">
        <div class="ui negative message">
          <div class="header">搜索失败</div>
          <p>{{ error }}</p>
        </div>
      </div>

      <div v-else-if="searchResults" class="pan-search-results m-padded-tb-big">
        <div v-if="!searchResults.data || !searchResults.data.merged_by_type" class="no-results m-padded-tb-big">
          <div class="ui centered text">
            <div class="ui icon header">
              <i class="search icon"></i>
              <div class="content">暂无搜索结果</div>
            </div>
          </div>
        </div>
        <div v-else-if="Object.keys(searchResults.data.merged_by_type).length === 0" class="no-results m-padded-tb-big">
          <div class="ui centered text">
            <div class="ui icon header">
              <i class="search icon"></i>
              <div class="content">暂无搜索结果</div>
            </div>
          </div>
        </div>
        <div v-else>
          <!-- 统一的网盘资源栏目 -->
          <div class="result-group m-margin-bottom-big">
            <h3 class="ui dividing header m-text-thin">
              <!-- 网盘类型切换标签 -->
              <div class="ui top attached tabular menu" style="display: inline-flex !important; flex-direction: row !important; border: 1px solid #eaeaea; border-radius: 8px; overflow: hidden; margin-bottom: 10px;">
                <a class="item" :class="{active: activeDiskType === 'all'}" @click="switchDiskType('all')" :style="{'display': 'inline-block', 'padding': '8px 16px', 'border-right': '1px solid #eaeaea', 'transition': 'all 0.3s ease', 'background-color': activeDiskType === 'all' ? '#2185d0' : 'white', 'color': activeDiskType === 'all' ? 'white' : '#333'}">
                  全部
                </a>
                <a class="item" :class="{active: activeDiskType === 'baidu'}" @click="switchDiskType('baidu')" :style="{'display': 'inline-block', 'padding': '8px 16px', 'border-right': '1px solid #eaeaea', 'transition': 'all 0.3s ease', 'background-color': activeDiskType === 'baidu' ? '#2185d0' : 'white', 'color': activeDiskType === 'baidu' ? 'white' : '#333'}">
                  百度网盘
                </a>
                <a class="item" :class="{active: activeDiskType === 'aliyun'}" @click="switchDiskType('aliyun')" :style="{'display': 'inline-block', 'padding': '8px 16px', 'border-right': '1px solid #eaeaea', 'transition': 'all 0.3s ease', 'background-color': activeDiskType === 'aliyun' ? '#2185d0' : 'white', 'color': activeDiskType === 'aliyun' ? 'white' : '#333'}">
                  阿里云盘
                </a>
                <a class="item" :class="{active: activeDiskType === 'quark'}" @click="switchDiskType('quark')" :style="{'display': 'inline-block', 'padding': '8px 16px', 'border-right': '1px solid #eaeaea', 'transition': 'all 0.3s ease', 'background-color': activeDiskType === 'quark' ? '#2185d0' : 'white', 'color': activeDiskType === 'quark' ? 'white' : '#333'}">
                  夸克网盘
                </a>
                <a class="item" :class="{active: activeDiskType === 'magnet'}" @click="switchDiskType('magnet')" :style="{'display': 'inline-block', 'padding': '8px 16px', 'border-right': '1px solid #eaeaea', 'transition': 'all 0.3s ease', 'background-color': activeDiskType === 'magnet' ? '#2185d0' : 'white', 'color': activeDiskType === 'magnet' ? 'white' : '#333'}">
                  磁力链接
                </a>
                <a class="item" :class="{active: activeDiskType === 'xunlei'}" @click="switchDiskType('xunlei')" :style="{'display': 'inline-block', 'padding': '8px 16px', 'transition': 'all 0.3s ease', 'background-color': activeDiskType === 'xunlei' ? '#2185d0' : 'white', 'color': activeDiskType === 'xunlei' ? 'white' : '#333'}">
                  迅雷网盘
                </a>
              </div>
            </h3>
            
            <!-- 分页控制 -->
            <div v-if="filteredLinks.length > 0" class="ui pagination menu" style="margin-bottom: 20px; justify-content: center;">
              <a class="item" @click="changePage('all', currentPage - 1)" :class="{disabled: currentPage <= 1}">
                <i class="left chevron icon"></i>
              </a>
              <a class="item active">{{ currentPage }} / {{ totalPages }}</a>
              <a class="item" @click="changePage('all', currentPage + 1)" :class="{disabled: currentPage >= totalPages}">
                <i class="right chevron icon"></i>
              </a>
            </div>
            
            <!-- 结果卡片 -->
            <div class="results-grid">
              <div v-for="(link, index) in paginatedFilteredLinks" :key="index" class="result-card">
                <div class="card-content">
                  <div class="card-title">{{ link.note }}</div>
                  <div class="card-meta">
                    <span v-if="link.datetime" class="meta-item">
                      <i class="calendar icon"></i>{{ formatDate(link.datetime) }}
                    </span>
                    <span v-if="link.source" class="meta-item">
                      <i class="info circle icon"></i>{{ link.source }}
                    </span>
                  </div>
                  <div class="card-actions">
                    <button class="ui primary button" @click="copyLinkWithPassword(link)" style="text-align: center; flex: 1; margin-right: 8px;">
                      <i class="link icon"></i>复制链接
                    </button>
                    <button class="ui primary button" @click="openLinkInNewTab(link)" style="text-align: center; flex: 1;">
                      <i class="external alternate icon"></i>新标签打开
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="filteredLinks.length === 0" class="no-results">
                <div class="ui centered text">
                  <div class="ui icon header">
                    <i class="search icon"></i>
                    <div class="content">暂无搜索结果</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkHealth, searchNetDisk } from '@/api/pan'

export default {
  name: 'PanSearchPage',
  data() {
    return {
      keyword: '',
      searchResults: null,
      loading: false,
      error: null,
      checkingHealth: true,
      serviceHealthy: false,
      // 每页显示的结果数量
      pageSize: 10,
      // 当前页码
      currentPage: 1,
      // 当前激活的网盘类型
      activeDiskType: 'all'
    }
  },
  mounted() {
    this.checkServiceHealth()
  },
  computed: {
    // 所有链接合并为一个数组
    allLinks() {
      if (!this.searchResults || !this.searchResults.data || !this.searchResults.data.merged_by_type) {
        return []
      }
      let allLinks = []
      Object.values(this.searchResults.data.merged_by_type).forEach(links => {
        allLinks = allLinks.concat(links)
      })
      return allLinks
    },
    // 根据当前选中的网盘类型过滤链接
    filteredLinks() {
      if (this.activeDiskType === 'all') {
        return this.allLinks
      }
      if (!this.searchResults || !this.searchResults.data || !this.searchResults.data.merged_by_type) {
        return []
      }
      return this.searchResults.data.merged_by_type[this.activeDiskType] || []
    },
    // 分页后的过滤结果
    paginatedFilteredLinks() {
      if (this.filteredLinks.length === 0) {
        return []
      }
      // 计算分页数据
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.filteredLinks.slice(start, end)
    },
    // 计算总页数
    totalPages() {
      if (this.filteredLinks.length === 0) {
        return 1
      }
      return Math.ceil(this.filteredLinks.length / this.pageSize)
    }
  },
  methods: {
    checkServiceHealth() {
      this.checkingHealth = true
      checkHealth().then(res => {
        console.log('健康检查结果:', res)
        this.serviceHealthy = res.data && res.data.status === 'ok'
        this.checkingHealth = false
      }).catch(err => {
        console.error('服务健康检查失败:', err)
        this.serviceHealthy = false
        this.checkingHealth = false
      })
    },
    search() {
      if (!this.keyword.trim()) {
        this.$message.warning('请输入搜索关键词')
        return
      }

      if (!this.serviceHealthy) {
        this.$message.error('服务不可用，请稍后再试')
        return
      }

      this.loading = true
      this.error = null
      this.searchResults = null
      this.currentPage = 1
      this.activeDiskType = 'all' // 重置为全部

      searchNetDisk(this.keyword).then(res => {
        console.log('搜索结果:', res)
        this.searchResults = res.data
        this.loading = false
      }).catch(err => {
        console.error('搜索失败:', err)
        this.error = err.message || '搜索失败，请稍后重试'
        this.searchResults = null
        this.loading = false
      })
    },
    // 切换网盘类型
    switchDiskType(type) {
      this.activeDiskType = type
      this.currentPage = 1 // 切换类型时重置页码
    },
    changePage(type, page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
      }
    },
    getDiskTypeName(type) {
      const typeMap = {
        baidu: '百度网盘',
        aliyun: '阿里云盘',
        quark: '夸克网盘',
        magnet: '磁力链接',
        xunlei: '迅雷网盘'
      }
      return typeMap[type] || type
    },
    getDiskTypeColor(type) {
      const colorMap = {
        baidu: 'blue',
        aliyun: 'orange',
        quark: 'yellow',
        magnet: 'red',
        xunlei: 'green'
      }
      return colorMap[type] || 'gray'
    },
    copyLinkWithPassword(link) {
      // 复制包含提取码的完整链接
      let fullLink = link.url
      if (link.password) {
        // 尝试在链接后添加提取码信息
        if (fullLink.endsWith('#')) {
          fullLink = fullLink + link.password
        } else if (fullLink.includes('?')) {
          fullLink = fullLink + '&pwd=' + link.password
        } else {
          fullLink = fullLink + '?pwd=' + link.password
        }
      }
      navigator.clipboard.writeText(fullLink).then(() => {
        this.$message.success('链接已复制')
      })
    },
    openLinkInNewTab(link) {
      // 在新标签页打开链接
      let fullLink = link.url
      if (link.password) {
        // 尝试在链接后添加提取码信息
        if (fullLink.endsWith('#')) {
          fullLink = fullLink + link.password
        } else if (fullLink.includes('?')) {
          fullLink = fullLink + '&pwd=' + link.password
        } else {
          fullLink = fullLink + '?pwd=' + link.password
        }
      }
      window.open(fullLink, '_blank')
    },
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString()
    }
  }
}
</script>

<style scoped>
.pan-search-page {
  min-height: 80vh;
  padding-top: 10px;
  background-color: #f5f5f5;
  padding-bottom: 40px;
}

.search-box {
  text-align: center;
  margin-bottom: 10px;
  padding: 0 20px;
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  padding: 20px 0;
  margin: 0 20px 10px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #eaeaea;
}

.service-status {
  padding: 20px 0;
  text-align: center;
  margin: 0 20px 10px;
}

.no-results {
  text-align: center;
  padding: 20px 0;
  margin: 0 20px 10px;
}

.result-group {
  margin: 0 20px 15px;
}

/* 标题样式 */
.result-group h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
  border-bottom: 1px solid #eaeaea;
  padding-bottom: 8px;
  display: block;
}

/* 分页样式 */
.ui.pagination.menu {
  margin-bottom: 10px;
  justify-content: center;
}

.ui.pagination.menu .item {
  font-size: 13px;
  padding: 6px 10px;
}

/* 网格布局 */
.results-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  width: 100%;
}

.result-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  width: 100%;
  border: 1px solid #eaeaea;
}

.result-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
}

.card-content {
  padding: 20px;
  width: 100%;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #333;
  line-height: 1.4;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
}

.card-meta {
  margin-bottom: 20px;
  font-size: 14px;
  color: #666;
  width: 100%;
}

.meta-item {
  margin-right: 15px;
  display: inline-flex;
  align-items: center;
}

.meta-item i {
  margin-right: 5px;
  color: #999;
}

.card-actions {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

/* 按钮样式 */
.ui.primary.button {
  font-size: 14px;
  padding: 8px 20px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.ui.primary.button:hover {
  background-color: #2185d0;
  box-shadow: 0 2px 8px rgba(33, 133, 208, 0.3);
}

/* 响应式调整 */
@media (max-width: 768px) {
  .pan-search-page {
    padding-top: 60px;
  }
  
  .search-box {
    padding: 0 15px;
  }
  
  .result-group {
    margin: 0 15px 30px;
  }
  
  .results-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .card-content {
    padding: 15px;
  }
  
  .card-title {
    font-size: 14px;
  }
  
  .ui.large.action.input {
    max-width: 100%;
  }
}
</style>